import { Modal } from 'antd';
import React, { Suspense, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from '../../components/private-route';
import { SESSION_EXPIRE_TIME } from '../../constants/constants';
import MainLayout from '../../layouts/main-layout';
import { logout, setUser } from '../../redux/authSlice';
import routes from '../../routes';
import axiosClient from '../../services/axiosClient';
import 'bootstrap/dist/css/bootstrap.css';
// import '../../components/familytree/css/cy.css';
import '../../components/familytree/css/style.css';
import '../../components/familytree/css/app.css';
import '../../components/familytree/css/bootstrap-table.css';
import './App.scss';
import {
  setTreeData,
  setTreeDataAndConfig,
  setTreeLoading,
} from '../../components/familytree/scripts/tree-slice';
import initData, {
  SAMPLE_4_LEVELS,
  testData,
} from '../../components/familytree/scripts/cy-constant';

function App() {
  const logoutTimeout = React.useRef(null);
  const [isSessionTimeout, setIsSessionTimeout] = React.useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const path = useMemo(() => '/dashboard', [user]);
  // const path = useMemo(() => {
  // if (checkPermisson(permissionConstants.DASHBOARD)) {
  //   return '/dashboard';
  // }
  // if (checkPermisson(permissionConstants.USERS_MANAGEMENT)) {
  //   return '/user-management';
  // }
  // if (
  //   checkPermissons([permissionConstants.EMAIL_TEMPLATE, permissionConstants.EMAIL_NOTIFICATION])
  // ) {
  //   return '/email-notification';
  // }
  // return '/admin/login';
  // }, [user]);

  const handleTimeout = () => {
    dispatch(logout());
  };

  const clearTimeoutFunc = () => {
    if (logoutTimeout.current) window.clearTimeout(logoutTimeout.current);
  };

  const setTimeoutFunc = () => {
    logoutTimeout.current = window.setTimeout(timeOut, SESSION_EXPIRE_TIME);
  };

  const resetTimeout = () => {
    clearTimeoutFunc();
    setTimeoutFunc();
  };

  const timeOut = () => {
    setIsSessionTimeout(true);
  };
  React.useEffect(() => {
    axiosClient.interceptors.request.use(
      (request) => {
        if (!request.url.includes('authorizer/login')) {
          resetTimeout();
        }
        if (request.url.includes('authorizer/logout')) {
          clearTimeoutFunc();
        }
        return request;
      },
      (error) => Promise.reject(error),
    );
    axiosClient.interceptors.response.use(
      (response) => {
        if (response?.config?.url?.includes('authorizer/login')) {
          setTimeoutFunc();
        }
        return response;
      },
      (error) => Promise.reject(error),
    );

    if (!user) {
      // // debug-console.log('Use Effect: user=', user);
      const savedUser = JSON.parse(localStorage.getItem('userInfo'));
      if (savedUser?.expireAt > Date.now()) {
        // debug-console.log('-------loaded user from storage------', savedUser);
        dispatch(setUser(savedUser));
        dispatch(setTreeLoading(true));
      } else {
        // dispatch(setTreeDataAndConfig(SAMPLE_4_LEVELS));
        dispatch(setTreeData(initData));
        // dispatch(setTreeDataAndConfig(testData));
      }
    }
  }, []);
  React.useEffect(() => {
    if (isSessionTimeout) {
      Modal.warning({
        title: 'Session Timed Out',
        content: (
          <>
            Your session has timed out <br /> Please Log In to continue.
          </>
        ),
        okText: 'Yes',
        cancelText: 'No',
        icon: null,
        centered: true,
        onOk() {
          handleTimeout();
        },
        onCancel() {},
      });
    }
  }, [isSessionTimeout]);
  const renderRoute = () =>
    routes.map((route) =>
      route.isPrivate ? (
        <PrivateRoute
          key={route.path}
          path={route.path}
          component={route.component}
          exact={route.exact}
          permissions={route.permissions}
        />
      ) : (
        <Route key={route.path} path={route.path} component={route.component} exact={route.exact} />
      ),
    );
  return (
    <div className="App">
      <Router
        getUserConfirmation={(message, callback) => {
          Modal.confirm({
            title: 'Changes may not be saved. Do you want to exit this page?',
            content: '',
            okText: 'Yes',
            cancelText: 'No',
            icon: null,
            centered: true,
            onOk() {
              callback(true);
            },
            onCancel() {},
          });
        }}
      >
        <Suspense fallback={<></>}>
          <MainLayout>
            <Switch>
              <Redirect exact from="/" to={path} />
              {renderRoute()}
              <Redirect to="/404" />
            </Switch>
          </MainLayout>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
